import { useMutation } from "@apollo/client";

import {
  DeleteVideoInput,
  DeleteVideoMutation,
  DeleteVideoMutationVariables,
} from "../../API";
import { DELETE_VIDEO } from "../../common/operations/mutations";
import { successNotification } from "../../common/variables/notification";
import { handleApolloError } from "../../common/utils/handleApolloError";

export const useDeleteVideo = () => {
  const [removeVideo, { data, loading }] = useMutation<
    DeleteVideoMutation,
    DeleteVideoMutationVariables
  >(DELETE_VIDEO);

  const deleteVideo = async (input: DeleteVideoInput) => {
    await removeVideo({
      variables: {
        input,
      },
      onCompleted: response => {
        const { deleteVideo } = response;

        if (deleteVideo) {
          successNotification(`${deleteVideo.videoName} is deleted`);
        }
      },
      onError: handleApolloError,
      update(cache) {
        const normalizedId = cache.identify({
          id: input.videoId,
          __typename: "LeakFinderVideo",
        });

        cache.evict({ id: normalizedId });

        cache.gc();
      },
    });
  };

  return { deleteVideo, data, loading };
};
